import React, { useEffect, useState } from "react";
import Layout from "../component/Layout/Layout";
import { Link } from "react-router-dom";
import MeasurementDropdown from "./MeasurementDropdown";
import axios from "axios";
import { useAuth } from "../context/auth";
export default function Measurements() {
  const [auth] = useAuth();
  const [userId] = useState(auth?.user.id);
  const[name, setName] = useState('');
  const[savedMgmt, setSavedMgmt] = useState('');
  const[selectedMgmt, setSelectedMgmt] = useState({});
  const [errMsg, setErrMsg] = useState({});
  const[saveText, setSaveText] = useState('SAVE');
  const [mgmtSelected, setMgmtSelected] = useState(false);
  const [requiredMesure] = useState(['name','m_shoulders','m_arm_hole','m_front_neck','m_back_neck','m_yoke_lenght','m_bust','m_waist','m_upper_arm','m_lower_arm','m_sleeves','m_hips','m_dart_point','m_full_length','m_lower_length','m_mori','m_thigh']);
  const[initialMeasure, setInitialMeasure] = useState({
                                                        customer_id:userId,
                                                        name:'',
                                                        m_shoulders:'',
                                                        m_arm_hole:'',
                                                        m_front_neck:'',
                                                        m_back_neck:'',
                                                        m_yoke_lenght:'',
                                                        m_bust:'',
                                                        m_waist:'',
                                                        m_wearing_waist:'',
                                                        m_upper_arm:'',
                                                        m_lower_arm:'',
                                                        m_sleeves:'',
                                                        m_hips:'',
                                                        m_dart_point:'',
                                                        m_full_length:'',
                                                        m_lower_length:'',
                                                        m_mori:'',
                                                        m_thigh:'',
                                                        m_upper_bust:'',
                                                        m_under_bust:'',
                                                        m_off_shoulder:'',
                                                    });
          const [measurement, setMeasurement] = useState(initialMeasure);
         
          const handleState=(name, value)=>{
                                            if(name==='name'){
                                              setName(value)
                                            }
                                            setMeasurement({
                                              ...measurement,
                                              [name]:value
                                            })
                                          }

          const handleSubmit = async(e)=>{
            setErrMsg({});
            e.preventDefault();
            for (const [key, value] of Object.entries(measurement)) {
              if(requiredMesure.includes(key) && value.trim()===''){
                if(key==='name'){
                  setErrMsg({cls:'alert alert-danger text-center mt-3', msg:'Name is required!'});
                }else{
                  setErrMsg({cls:'alert alert-danger text-center mt-3', msg:'All essential measurements are required!'});
                }
                
                return false;
              }
            }

            try {
                let {data} = await axios.post(`${process.env.REACT_APP_API_URL}/customer/measurement/add_measurement`,measurement);
                if(data?.status){
                  setErrMsg({cls:'alert alert-success text-center mt-3', msg:data?.message});
                  getMeasurement();
                }
            } catch (error) {
                console.log(error)
            }
          }
          
          const getMeasurementById = async(e)=>{
            setErrMsg({});
            let id = e.target.value;
            if(id==='new'){
              setName('')
              setMgmtSelected(false);
              setSaveText('SAVE');
              setMeasurement({...initialMeasure});
              return;
            }
            setMgmtSelected(true);
            setSaveText('UPDATE');
            id = Number(id);
            let selectedData = savedMgmt.filter(item=>item.id===id);
           
            if(selectedData.length>0){
              let s_data = selectedData[0];             
              let userMgmt = JSON.parse(s_data?.mgmt);          
              
              let user_data = {id:s_data.id,name:s_data.name};            
              setMeasurement({...measurement,...userMgmt,...user_data});
            }
          }
    const getMeasurement = async()=>{
            try {
              let {data} = await axios.get(`${process.env.REACT_APP_API_URL}/customer/measurement/get_measurement?customer_id=${userId}`);
              console.log(data)
              if(data?.status){
                setSavedMgmt(data?.result);
              }
            } catch (error) {
              console.log(error)
            }
          }
      useEffect(()=>{
        getMeasurement();
      },[])

  return (
    <Layout title="Measurements | Chaashni by Maansi & Ketan">
      <div className="site-content-wrap my-account">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="sustom-heading-h1">Measurements</h1>
              <div className="content-box">
              <div className="video-box-measurment">
                <div className="video-box-text">
                  <p>Please closely follow the video to record your measurements.<br />
                    Whilst you can do it your own, we suggest taking help for more accuracy.</p>
                </div>

                <div className="video-box-video youtube-video-wrap">
                  <div className="youtube-video-wrap hi"><img src="/images/youtube-img.jpg" alt="" loading="lazy" />
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/sYt-m98__Vc?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
                  </div>
                </div>
                </div>
        <form novalidate id="measurement-form" onSubmit={handleSubmit}>
          <div className="measurement-form-section">
            {savedMgmt.length>0 && savedMgmt?(
              <ul className="measurement-person">
                <li className="person-name">
                  <label> Select:</label>
                  <div className="input-drop-down">
                    <select onChange={getMeasurementById}>
                      <option value=''>--Select--</option>
                        {savedMgmt?.map((item,i)=>(
                          <option key={i} value={item.id}>{item.name}</option>
                        ))}
                      <option key='new' value='new'>+ Add New Measurement</option>
                    </select>
                    </div>
                </li>
              </ul>
            ):''}

            {!mgmtSelected?(
              <ul className="measurement-person">
              <li className="person-name">
                <label> Measurement for:</label>
                <div className="input-drop-down">
                  <input type="text" name="name" value={name} placeholder="Full Name" className="form-controle" onChange={(e)=>{ handleState(e.target.name, e.target.value ) }}/>               
                </div>
              </li>
            </ul>
            ):''}
            
          </div>

          <div className="measurement-form-section">
            <h2>ESSENTIAL MEASUREMENTS</h2>
            <div className="small-text">In Inches</div>
            <ul>
              <li>
                <label>Shoulders</label>
                <div className="input-drop-down">
                  <MeasurementDropdown name='m_shoulders' mvalue={measurement.m_shoulders} min={11} max={25.5} changeHandle={handleState} />
                </div>
              </li>
          
              <li>
                <label>Arm Hole</label>
                <div className="input-drop-down">
                  <MeasurementDropdown name='m_arm_hole' mvalue={measurement.m_arm_hole} min={2} max={15.5} changeHandle={handleState} />
                </div>
              </li>
              <li>
              <label>Front Neck</label>
              <div className="input-drop-down">
              <MeasurementDropdown name='m_front_neck' mvalue={measurement.m_front_neck} min={2} max={20.5} changeHandle={handleState} />
              </div>
            </li>
            <li>
            <label>Back Neck</label>
            <div className="input-drop-down">
            <MeasurementDropdown name='m_back_neck' mvalue={measurement.m_back_neck} min={2} max={20.5} changeHandle={handleState} />
            </div>
          </li>
              
              <li>
                <label>Yoke Length</label>
                <div className="input-drop-down">
                <MeasurementDropdown name='m_yoke_lenght' mvalue={measurement.m_yoke_lenght} min={5} max={50.5} changeHandle={handleState} />
                 
                </div>
              </li>
             
              <li>
                <label>Bust</label>
                <div className="input-drop-down">
                <MeasurementDropdown name='m_bust' mvalue={measurement.m_bust} min={20} max={50.5} changeHandle={handleState} />
                 
                </div>
              </li>
              <li>
                <label>Waist</label>
                <div className="input-drop-down">
                <MeasurementDropdown name='m_waist' mvalue={measurement.m_waist} min={20} max={50.5} changeHandle={handleState} />
                 
                </div>
              </li>
              <li>
                <label>Wearing Waist</label>
                <div className="input-drop-down">
                <MeasurementDropdown name='m_wearing_waist' mvalue={measurement.m_wearing_waist} min={20} max={50.5} changeHandle={handleState} />
                </div>
              </li>
              <li>
                <label>Upper Arm</label>
                <div className="input-drop-down">
                  <MeasurementDropdown name='m_upper_arm' mvalue={measurement.m_upper_arm} min={9} max={50.5} changeHandle={handleState} />
                </div>
              </li>
              <li>
                <label>Lower Arm</label>
                <div className="input-drop-down">
                  <MeasurementDropdown name='m_lower_arm' mvalue={measurement.m_lower_arm} min={9} max={50.5} changeHandle={handleState} />
                </div>
              </li>
              <li>
                <label>Sleeves</label>
                <div className="input-drop-down">
                  <MeasurementDropdown name='m_sleeves' mvalue={measurement.m_sleeves} min={2} max={25.5} changeHandle={handleState} />
                </div>
              </li>
              <li>
                <label>Hips</label>
                <div className="input-drop-down">
                  <MeasurementDropdown name='m_hips' mvalue={measurement.m_hips} min={20} max={50.5} changeHandle={handleState} />
                </div>
              </li>
              <li>
                <label>Dart Point</label>
                <div className="input-drop-down">
                  <MeasurementDropdown name='m_dart_point' mvalue={measurement.m_dart_point} min={5} max={50.5} changeHandle={handleState} />
                </div>
              </li>
              <li>
                <label>Full Length (with heels)</label>
                <div className="input-drop-down">
                  <MeasurementDropdown name='m_full_length' mvalue={measurement.m_full_length} min={20} max={80.5} changeHandle={handleState} />
                </div>
              </li>
              <li>
                <label>Lower Length (with heels)</label>
                <div className="input-drop-down">
                  <MeasurementDropdown name='m_lower_length' mvalue={measurement.m_lower_length} min={20} max={55} changeHandle={handleState} />
                </div>
              </li>
              <li>
                <label>Mori (Ankle)</label>
                <div className="input-drop-down">
                  <MeasurementDropdown name='m_mori' mvalue={measurement.m_mori} min={13} max={17} changeHandle={handleState} />
                </div>
              </li>
              <li>
                <label>Thigh</label>
                <div className="input-drop-down">
                  <MeasurementDropdown name='m_thigh' mvalue={measurement.m_thigh} min={22} max={35} changeHandle={handleState} />
                </div>
              </li>
             
            </ul>
          </div>
         
          <div className="measurement-form-section">
            <h2>OPTIONAL MEASUREMENTS</h2>
            <div className="small-text">In Inches</div>
            
            <ul>
              <li>
                <label>Upper Bust</label>
                <div className="input-drop-down">
                  <MeasurementDropdown name='m_upper_bust' mvalue={measurement.m_upper_bust} min={20} max={50.5} changeHandle={handleState} />
                </div>
              </li>
              <li>
                <label>Under Bust</label>
                <div className="input-drop-down">
                  <MeasurementDropdown name='m_under_bust' mvalue={measurement.m_under_bust} min={20} max={50.5} changeHandle={handleState} />
                </div>
              </li>
              <li>
                <label>Off Shoulder</label>
                <div className="input-drop-down">
                  <MeasurementDropdown name='m_off_shoulder' mvalue={measurement.m_off_shoulder} min={5} max={30.5} changeHandle={handleState} />
                </div>
              </li>
            </ul>
         
            <div className="save-button">
              <input type="submit" name="submit" value={saveText} />
            </div>
            {errMsg.cls? <div className={errMsg.cls}>{errMsg.msg}</div>:'' }
          </div>
        </form>
       

              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
